export default __webpack_public_path__ + "static/media/tl.1ca0aa37.svg";